import React, { useState,useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import './dashboard.css'
import { useNavigate } from "react-router-dom"; // Import useNavigate

const validateMSISDN = (msisdn) => {
  if (msisdn.length === 13 && msisdn.startsWith("+92")) {
    return msisdn.slice(1);
  } else if (msisdn.length === 12 && msisdn.startsWith("92")) {
    return msisdn;
  } else if (msisdn.length === 11 && msisdn.startsWith("0")) {
    return "92" + msisdn.slice(1);
  } else if (msisdn.length === 10 && msisdn.startsWith("3")) {
    return "92" + msisdn;
  } else {
    return false;
  }
};

const verifyToken = () => {
    const token = localStorage.getItem("authToken");
    const expiry = localStorage.getItem("tokenExpiry");

    if (!token || Date.now() > expiry) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("tokenExpiry");
      return false; // Token invalid or expired
    }
    return true; // Token is valid
  };


const Dashboard = () => {
  const [msisdn, setMsisdn] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [subscriber, setSubscriber] = useState(null);
  const [selectedService, setSelectedService] = useState("");
  const [selectedClass, setSelectedClass] = useState("ucloudcontainer");
  const [IsAuthenticated, setIsAuthenticated] = useState(false);
  const navigate=useNavigate();


  const [services, setServices] = useState([
    { name: "Ufone Secureteen", value: "secureteen" },
    { name: "Ufone Busuu", value: "busuu" },
    { name: "Ufone UCloud", value: "ucloud" },
    { name: "Ufone Fitflex", value: "fitflex" },
    { name: "Ufone Kidjo", value: "kidjo" },
    { name: "Ufone VIP CALL", value: "uvipcall" },
  ]);
  useEffect(() => {
    if (verifyToken()) {
    setIsAuthenticated(true); // User is authenticated, valid token exists
    const url = new URL(window.location);
    url.searchParams.delete("user");
    url.searchParams.delete("pass");
    window.history.replaceState({}, "", url.toString());
    }
    else
    {
      
      const url = new URL(window.location);
      const user = url.searchParams.get("user");
      const pass = url.searchParams.get("pass");



      //console.log(user,pass);
      if(user && pass)
      navigate(`/login?user=${btoa(user)}&pass=${btoa(pass)}`);
      else
      navigate(`/login`);
    }
  }, []);

  const handleUnsub = async () => {
    if (!selectedService) {
      setMessage("Please select a service to unsubscribe.");
      setMessageType("error");
      return;
    }
  
    const validatedMsisdn = validateMSISDN(msisdn);
    if (!validatedMsisdn) {
      setMessage("Invalid MSISDN");
      setMessageType("error");
      setSubscriber(null);
      return;
    }
  
    try {
        let response
        if(selectedService=='secureteen')
        {
    response = await unsubscribeSecureteenUser(validatedMsisdn);
        }
        else if(selectedService=='busuu')
        {
    response = await unsubscribeBusuuUser(validatedMsisdn);
        }
        else if(selectedService=='fitflex')
        {
    response = await unsubscribeFitflexUser(validatedMsisdn);
        }
        else if(selectedService=='ucloud')
        {
    response = await unsubscribeUcloudUser(validatedMsisdn);
        }
        else if(selectedService=='kidjo')
        {
    response = await unsubscribeKidjoUser(validatedMsisdn);     
        }
        else if (selectedService=='uvipcall')
        {
    response = await callUvipsubsAPI(validatedMsisdn,"unsub");
        }

      
      if (response?.success) {
        setMessage(`Unsubscribed from ${selectedService} successfully.`);
        setMessageType("success");
      } else {
        if(response.message=="Success" || response.message=="Please Subscribe to any package first" || response.message=="Unsubscriber Successfully")
        {
        setMessage(`Unsubscribed from ${selectedService} successfully.`);
        setMessageType("success");
        }
        else if(response?.code === 1000)
        {
        setMessage(`Unsubscribed from ${selectedService} successfully.`);
        setMessageType("success");
        }
        
        else if(response?.error)
        {
        if(response.error=="User does not exist to unsub")
        {
        setMessage(`Already Unsubscribe from ${selectedService}.`);
        setMessageType("error");
        }
      
        else
        setMessage(`Unsubscribed from ${selectedService} successfully.`);
        setMessageType("success");
        }
       
        else
        {
        setMessage(`${response?.message} from ${selectedService}.`);
        setMessageType("error");
        }
      }
  
      setSubscriber(null); // Clear subscriber data after unsubscribe
    } catch (error) {
      if(error?.message == "Cannot read properties of null (reading 'message')")
      {
        setMessage("Unable to Unsubscribe User. Please try again later.");
        setMessageType("error");
        setSubscriber(null);
      }
      else
      {
      setMessage("Error during unsubscription: " + error.message);
      setMessageType("error");
      }
    }
  };
  
  const unsubscribeSecureteenUser = async (msisdn, deviceType = "WEB", operator = "ufone") => {
    const url = "http://18.136.62.227:3300/unsubscribe";
    const data = JSON.stringify({
      msisdn,
      device_type: deviceType,
      operator,
    });
  
    const headers = {
      "Content-Type": "application/json",
      "Authorization": "Basic c3dpdGNoOnNlY3VyZXRlZW5AMTIz",
    };
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: data,
      });
  
      if (!response.ok) {
        throw new Error("Failed to unsubscribe");
      }
  
      const responseData = await response.json();
      return responseData; // Assuming the response contains a success field
    } catch (error) {
      console.error("Error:", error);
      throw new Error(error.message || "Failed to call unsubscribe API");
    }
  };

  const unsubscribeBusuuUser = async (msisdn) => {
    const url = "http://api.ufonebusuu.com/ufone/unsubuserPortal";
  
    const data = {
      msisdn: msisdn,
    };
  
    const headers = {
      "Content-Type": "application/json",
    };
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        throw new Error("Failed to unsubscribe user");
      }
  
      const responseData = await response.json();
      return responseData; // Returning the response data
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  const unsubscribeFitflexUser = async (msisdn) => {
    const url = 'https://prod.fitflexapp.com/api/unSubscribePortal?msisdn='+msisdn;
    const data = { msisdn: msisdn };
  
    const headers = {
      'Content-Type': 'application/json',
    };
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,

      });
  
      if (!response.ok) {
        throw new Error('Failed to unsubscribe user');
      }
  
      const responseData = await response.json();
      return responseData; // Returning the response data
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const unsubscribeKidjoUser = async (msisdn) => {
    const url = "https://api.jazzkidjo.com/unsubscribeUserUfone";
    const data = {
      msisdn: msisdn,
    };
  
    const headers = {
      "Content-Type": "application/json",
      "Authorization": "Basic S2lkam9QUk9EQVBJczoxMjNAS2lkam9QUk9E",
    };
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        const responseData = await response.json();
        return responseData;
      }
  
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error:", error);
      return null
    }
  };

  const unsubscribeUcloudUser = async (msisdn) => {
    const url = `http://ccportal.switch.com.pk/unsub.php?msisdn=${msisdn}`;
    
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
  
    const data = "grant_type=client_credentials";
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: data,
      });
  
      if (!response.ok) {
          
      const responseData = await response.json()
        return responseData;
      }
  
      const responseData = await response.json(); 
      return responseData; 
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  const callUvipsubsAPI = async (msisdn, type) => {
  const url = 'http://ccportal.switch.com.pk/Uvipsubs.php';

  const headers = {
    'Content-Type': 'application/json',
  };

  const body = JSON.stringify({
    msisdn: msisdn,
    type: type,
  });

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: body,
    });

    const responseData = await response.json();
    if(type=='sub' && !responseData.data)
    {

    responseData.data = "Subscriber Not Found" ;
    
    }
      return responseData;

  } catch (error) {
    console.error('Error calling Uvipsubs.php:', error);
    return null;
  }
};

  
  
  
  
  
  const getFitflexDetails = async (msisdn) => {
    const url = `https://mediation.fitflexapp.com/getDbDetails.php`;
    const username = 'UfonePortal';
    const password = 'UF0N3PorT@l@123'; 
  
    // Encoding credentials to Base64 for Basic Auth
    const base64Credentials = btoa(`${username}:${password}`);
  
    try {
      const response = await fetch(url, {
        method: 'POST', // Ensure method is POST
        headers: {
          'Content-Type': 'application/json', // Send JSON data
          'Authorization': `Basic ${base64Credentials}`, // Basic Auth
        },
        body: JSON.stringify({ msisdn }), // Send msisdn in the request body
      });
      
      const data = await response.json();
      if(data?.message=="No record found")
      {
        return data.message
      }
  
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
  

      return data.data; // Returning the response data
    } catch (error) {
      console.error('Error:', error.message);
      return null;
    }
  };
  

  const getKidjoDetails = async (msisdn) => {
    const url = `https://api.jazzkidjo.com/getKidjoUfoneUserStats`;
    const username = 'UfonePortal';
    const password = 'UF0N3PorT@l@123';
    
    const base64Credentials = btoa(`${username}:${password}`); // Encoding credentials to base64 for Basic Auth
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Basic ${base64Credentials}`,
            },
            body: JSON.stringify({ msisdn }),
          });
  
          const data = await response.json();
      if(data?.message=="No record found")
      {
        return data.message
      }
  
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
  
      return data.data; // Returning the response data
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };

  const getBusuuDetails = async (msisdn) => {
    const url = `http://api.ufonebusuu.com/ufone/portalData`;
    const username = 'UfonePortal';
    const password = 'UF0N3PorT@l@123';
    
    const base64Credentials = btoa(`${username}:${password}`); // Encoding credentials to base64 for Basic Auth
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Basic ${base64Credentials}`, // Setting the Basic Auth header
        },
        body: JSON.stringify({ msisdn }), // Send msisdn in the body as a JSON object
      });
  
      const data = await response.json();
      if(data?.message=="No record found")
      {
        return data.message
      }
  
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      return data.data; // Returning the response data
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };
  const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // Handle empty string
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const getUcloudDetails = async (msisdn) => {
    const url = `http://ccportal.switch.com.pk/getUserStats.php`;
    const username = 'UfonePortal';
    const password = 'UF0N3PorT@l@123';
  
    // Encoding credentials to Base64 for Basic Auth
    const base64Credentials = btoa(`${username}:${password}`);
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Basic ${base64Credentials}`, // Setting the Basic Auth header
        },
        body: JSON.stringify({ msisdn }), // Sending msisdn in the body
      });
  
      const data = await response.json();
      if(data?.message=="No record found")
      {
        return data.message
      }
  
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
  
      return data.data; // Return the response data
    } catch (error) {
      console.error('Error:', error.message);
      return null;
    }
  };
  
  
  
  

  const getSecureteenDetails = async (msisdn) => {
    const url = `http://18.136.62.227:3300/getDbdetails?msisdn=${msisdn}`;
    const username = 'UfonePortal';
    const password = 'UF0N3PorT@l@123';
  
    const base64Credentials = btoa(`${username}:${password}`); // Encoding credentials to base64 for Basic Auth
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${base64Credentials}`, // Setting the Basic Auth header
        },
      });

      const data = await response.json();
      if(data?.message=="No record found")
      {
        return data.message
      }
  
      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }
  
      //console.log(data); // Handle the response data
      return data.data;
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  };
  

  

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validatedMsisdn = validateMSISDN(msisdn);
  
    if (!validatedMsisdn) {
      setMessage("Invalid MSISDN");
      setMessageType("error");
      setSubscriber(null);
      return;
    }
  
    // Simulating fetching subscriber data
    const getSubscriberData = async (msisdn, service) => {
        try{
    if (service === "secureteen") {
        
          // Call the asynchronous getSecureteenDetails function
          const data = await getSecureteenDetails(msisdn);
          if(typeof data =="string")
          return data
          return {
            msisdn: data.msisdn,
            subscriptionStatus: data.subscription_status === 1 ? "Active" : "Inactive",
            subscriptionDate:  data.subscription_date ,
            subscriptionChannel:data.channel,
            unsubscriptionChannel:data.unsub_channel,
            unsubscriptionDate: data.unsub_date,
            lastBilledDate: (data.last_billed_date === "1970-01-02 00:00:00" ? "None" : data.last_billed_date) ,
          };
        
    }
    else if(service === "busuu")
    {
        const data = await getBusuuDetails(msisdn);
        if(typeof data =="string")
          return data
        return {
            msisdn: data.msisdn,
            subscriptionStatus: data.subscription_status === 1 ? "Active" : "Inactive",
            subscriptionDate: data.subscription_date ,
            subscriptionChannel:data.channel,
            unsubscriptionChannel:data.unsub_channel,
            unsubscriptionDate: data.unsub_date,
            lastBilledDate: (data.last_billed_date === "1970-01-02 00:00:00" ? "None" : data.last_billed_date),
          };

    }
    else if(service === "kidjo")
    {
        const data = await getKidjoDetails(msisdn);
        if(typeof data =="string")
          return data
        return {
            msisdn: data.msisdn,
            subscriptionStatus: data.subscription_status === 1 ? "Active" : "Inactive",
            subscriptionDate: data.subscription_date,
            subscriptionChannel:data.channel,
            unsubscriptionChannel:data.unsub_channel,
            unsubscriptionDate: data.unsub_date,
            lastBilledDate: (data.last_billed_date === "1970-01-02 00:00:00" ? "None" : data.last_billed_date),
          };
          
    }
    else if(service === "fitflex")
    {
        const data = await getFitflexDetails(msisdn);
        if(typeof data =="string")
          return data
        console.log(data);
        return {
            msisdn: data.msisdn,
            subscriptionStatus: data.subscription_status === 1 ? "Active" : "Inactive",
            subscriptionDate:data.subscription_date,
            subscriptionChannel:data.channel,
            unsubscriptionChannel:data.unsub_channel,
            unsubscriptionDate: data.unsub_date,
            lastBilledDate:(data.last_billed_date === "1970-01-02 00:00:00" ? "None" : data.last_billed_date),
          };
    }
    else if(service === "ucloud")
    {
        const data = await getUcloudDetails(msisdn);
        if(typeof data =="string")
          return data
        return {
            msisdn: data.msisdn,
            subscriptionStatus: data.subscription_status == 1 ? "Active" : "Inactive",
            subscriptionDate: data.subscription_date,
            subscriptionChannel:data.channel,
            unsubscriptionChannel:data.unsub_channel,
            unsubscriptionDate: data.unsubscription_date,
            lastBilledDate: (data.last_billed_date == "1970-01-02 00:00:00" ? "None" : data.last_billed_date),
          };
    }
    else if(service === "uvipcall")
    {
        const dataRes = await callUvipsubsAPI(msisdn,"sub");
        const data= dataRes.data;
        console.log(data);
        if(typeof data =="string")
          return data
        return {
            msisdn: data.msisdn,
            subscriptionStatus: data.status == 1 ? "Active" : data.status == 6 ? "Inactive" : data.status == 2 ?"Pending Unsubscription Callback from Ufone" : "Pending Subscription Callback from Ufone",
            subscriptionDate:  data.subDate,
            subscriptionChannel:data.channel,
            unsubscriptionChannel:data.unsubChannel,
            unsubscriptionDate: data.unsubDate,
            lastBilledDate:  (data?.last_billed_date == "1970-01-02 00:00:00" ? " " : data?.last_billed_date),
          };
    }        

    } catch (error) {
    console.error("Error fetching data:", error);
    setMessage("Failed to fetch subscriber details.");
    setMessageType("error");
    setSubscriber(null);
    return null;
  }
        
      return null;
    };
    
    if(IsAuthenticated)
    {
    const data = await getSubscriberData(validatedMsisdn, selectedService);
  
    if (data) {
      if(typeof data == "string")
      {
        setMessage("No subscriber found for this service");
        setMessageType("error");
        setSubscriber(null);
      }
      else
      {
      setSubscriber(data);
      setMessage("");
      setMessageType("");
      }
    } else {
      setMessage("Unable to fetch Msisdn Details. Please try again later");
      setMessageType("error");
      setSubscriber(null);
    }
}
else
{
    setMessage("Please Login First");
    setMessageType("error");
}
  };
  

  return (
    <Container maxWidth="sm" style={{ marginTop: "70px" }} className="container">
      <Card style={{ backgroundColor: "rgba(99, 99, 99, 0.0)", }}  >
        <CardContent>
            
          <Typography variant="h5" component="div" gutterBottom>
          <strong>{capitalizeFirstLetter(selectedService)}</strong>
          </Typography>


          <form onSubmit={handleSubmit} >
            <TextField
              fullWidth
              label="Enter MSISDN"
              variant="outlined"
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              placeholder="923XXXXXXXXX"
              margin="normal"
            />

            <FormControl fullWidth margin="normal">
              <InputLabel>Service</InputLabel>
              <Select
                value={selectedService}
                onChange={(e) => {setSelectedService(e.target.value);setSubscriber(null);setMessage("");setMessageType("")}}
                label="Service"
              >
                {services.map((service) => (
                  <MenuItem key={service.value} value={service.value}>
                    {service.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              fullWidth
              type="submit"
              variant="contained"
              style={{ backgroundColor: "#EA7F2F", color: "white", width: "200px" }}
            >
              Check Subscription
            </Button>
          </form>

          {message && (
            <Alert severity={messageType} style={{ marginTop: "20px" }}>
              {message}
            </Alert>
          )}

          {subscriber && (
            <div style={{ marginTop: "20px" }}>
              <Typography variant="h6">Subscriber Details</Typography>
              <Typography>MSISDN: {subscriber.msisdn}</Typography>
              <Typography>Current Status: {subscriber.subscriptionStatus}</Typography>
              
              <Typography>
              Last Subscription Date: {subscriber.subscriptionDate}
              </Typography>

              {/* <Typography>
              Subscription Channel: {subscriber.subscriptionChannel}
              </Typography> */}
              
              <Typography>
              Last UnSubscription Date: {subscriber.unsubscriptionDate}
              </Typography>
              
              {/* <Typography>
              UnSubscription Channel: {subscriber.unsubscriptionChannel}
              </Typography> */}

              <Typography>
              Last Billed Date: {subscriber.lastBilledDate}
              </Typography>
              {subscriber.subscriptionStatus === "Active" ? (
              <Button
                onClick={handleUnsub}
                fullWidth
                variant="contained"
                style={{
                  backgroundColor: "#EA7F2F",
                  color: "white",
                  width: "200px",
                }}
              >
                UNSUB USER
              </Button> 
                ) : null}
            </div>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default Dashboard;
